import { Component, inject } from '@angular/core';
import { VehicleTypeService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VehicleTypeCreateDto,
  VehicleTypeDto,
  VehicleTypeExcelDownloadDto,
  VehicleTypeUpdateDto,
} from 'orchestrator';
import { VEHICLETYPE_CONFIG, VEHICLETYPE_FIELDS } from './vehicle-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-vehicle-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VehicleTypeService, ConfirmationService],
  templateUrl: './vehicle-type.html',
  styleUrl: './vehicle-type.scss',
})
export class VehicleType extends BaseCrudComponent<
  VehicleTypeDto,
  VehicleTypeCreateDto,
  VehicleTypeUpdateDto,
  VehicleTypeExcelDownloadDto
> {
  service = inject(VehicleTypeService);
  config = VEHICLETYPE_CONFIG;
  fields = VEHICLETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: VehicleTypeDto): VehicleTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      applyLowImpactTruck: data.applyLowImpactTruck,
      vehicleCategoryId: data.vehicleCategoryId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VehicleType';
  }
}
